// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import 'babel-polyfill'  
import Vue from 'vue'
import App from './App'
import router from './router'

import {langdetector} from '@/langdetector';

//SET IDIOMA
localStorage.setItem('language','es');

//CARRUSEL
import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);
//VUEX 
import Vuex from 'vuex'
Vue.use(Vuex)
import { store } from '@/store/store.js';
//.VUEX 

//AXIOS
import axios from 'axios'
import VueAxios from 'vue-axios'
axios.defaults.baseURL = store.state.server;
//.AXIOS

//VEE-VALIDATE
import VeeValidate, {Validator} from 'vee-validate';
import validatorEs from '@/validator/es';
Validator.localize('es', validatorEs);
Vue.use(VeeValidate);

//VEE-VALIDATE CUSTOM RULES
Validator.extend('postal_code', {
	getMessage: () => 'Introduce un código postal válido (5 dígitos)',
	validate: value => /^\d{5}$/.test(value) && Number(String(value).slice(0, 2)) >= 1 && Number(String(value).slice(0, 2)) <= 52,
});

Validator.extend('nif', {
	getMessage: () => 'Introduce un DNI, NIE o CIF válido',
	validate: value => isValidNif(value),
});

function isValidNif(value) {
	if (!value) return false;
	const v = String(value).toUpperCase().trim();
	const letters = 'TRWAGMYFPDXBNJZSQVHLCKE';

	const dni = v.match(/^(\d{8})([A-Z])$/);
	if (dni) return letters[Number(dni[1]) % 23] === dni[2];

	const nie = v.match(/^([XYZ])(\d{7})([A-Z])$/);
	if (nie) {
		const prefix = { X: '0', Y: '1', Z: '2' }[nie[1]];
		return letters[Number(prefix + nie[2]) % 23] === nie[3];
	}

	const klm = v.match(/^([KLM])(\d{7})([A-Z])$/);
	if (klm) return letters[Number(klm[2]) % 23] === klm[3];

	const cif = v.match(/^([ABCDEFGHJNPQRSUVW])(\d{7})([0-9A-J])$/);
	if (cif) {
		const digits = cif[2];
		let even = 0, odd = 0;
		for (let i = 0; i < digits.length; i++) {
			const n = Number(digits[i]);
			if (i % 2 === 0) {
				const d = n * 2;
				odd += Math.floor(d / 10) + (d % 10);
			} else {
				even += n;
			}
		}
		const control = (10 - ((even + odd) % 10)) % 10;
		const controlLetter = 'JABCDEFGHI'[control];
		if ('PQRSNW'.includes(cif[1])) return cif[3] === controlLetter;
		if ('ABEH'.includes(cif[1])) return cif[3] === String(control);
		return cif[3] === String(control) || cif[3] === controlLetter;
	}

	return false;
}
//.VEE-VALIDATE CUSTOM RULES


//IDIOMAS
import VueI18n from 'vue-i18n'
import messages from './translations';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: store.state.language, 
  messages,
});
//.IDIOMAS




Vue.config.productionTip = false

new Vue({
	el: '#app',
	router,
	i18n,
	store,
  	VeeValidate,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js